<template>
  <v-navigation-drawer
    :value="isMobile ? isMobileDrawerOpen : true"
    :mini-variant="isCollapsed"
    app
    :permanent="!isMobile"
    :temporary="isMobile"
    :width="isMobile ? 280 : 240"
    mini-variant-width="64"
    class="app-navigation-menu admin-sidebar"
    :right="$vuetify.rtl"
    @input="handleDrawerInput"
  >
    <div class="vertical-nav-header">
      <router-link
        to="/dashboard"
        class="admin-sidebar__brand text-decoration-none"
      >
        <v-img
          :src="isCollapsed ? require('@/assets/images/logos/adverport-logo-min.png') : require('@/assets/images/logos/adverport-logo.png')"
          :max-width="isCollapsed ? '40px' : '116px'"
          alt="logo"
          contain
          eager
          class="app-logo"
        ></v-img>
      </router-link>
    </div>

    <v-list
      expand
      shaped
      class="vertical-nav-menu-items"
    >
      <nav-menu-section-title
        v-if="!isCollapsed && showManagement"
        title="Overview"
      ></nav-menu-section-title>
      <nav-menu-link
        v-if="showManagement"
        title="Dashboard"
        :to="{ name: 'dashboard' }"
        :icon="icons.mdiViewDashboardOutline"
      ></nav-menu-link>

      <nav-menu-section-title
        v-if="!isCollapsed && showManagement"
        title="Kullanıcılar"
      ></nav-menu-section-title>
      <nav-menu-link
        v-if="showManagement"
        title="Kullanıcı Listesi"
        :to="{ name: 'userList' }"
        :icon="icons.mdiAccountSupervisor"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showManagement"
        title="Puan Yönetimi"
        :to="{ name: 'points' }"
        :icon="icons.mdiTrophyOutline"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showManagement"
        title="Başarımlar"
        :to="{ name: 'achievements' }"
        :icon="icons.mdiMedalOutline"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showManagement"
        title="Premium"
        :to="{ name: 'premium' }"
        :icon="icons.mdiCrownOutline"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showManagement"
        title="Referral İnceleme"
        :to="{ name: 'referralReviews' }"
        :icon="icons.mdiShieldAlertOutline"
      ></nav-menu-link>

      <nav-menu-section-title
        v-if="!isCollapsed && showFinance"
        title="Finans"
      ></nav-menu-section-title>
      <nav-menu-link
        v-if="showFinance"
        title="Para Transfer İstekleri"
        :to="{ name: 'cashTransfer' }"
        :icon="icons.mdiCash"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showFinance"
        title="Cüzdan Raporları"
        :to="{ name: 'walletReports' }"
        :icon="icons.mdiWalletOutline"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showFinance"
        title="Mutabakat"
        :to="{ name: 'settlements' }"
        :icon="icons.mdiClipboardCheckOutline"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showFinance"
        title="Conversionlar"
        :to="{ name: 'conversions' }"
        :icon="icons.mdiClipboardCheckOutline"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showFinance"
        title="Bankalar"
        :to="{ name: 'banks' }"
        :icon="icons.mdiBank"
      ></nav-menu-link>

      <nav-menu-section-title
        v-if="!isCollapsed && showFinance"
        title="Paraşüt"
      ></nav-menu-section-title>
      <nav-menu-link
        v-if="showFinance"
        title="Garanti Hesabı"
        :to="{ name: 'garantiAccount' }"
        :icon="icons.mdiBank"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showFinance"
        title="Giderler"
        :to="{ name: 'parasutExpenses' }"
        :icon="icons.mdiClipboardCheckOutline"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showFinance"
        title="Satış Faturaları"
        :to="{ name: 'parasutSalesInvoices' }"
        :icon="icons.mdiClipboardCheckOutline"
      ></nav-menu-link>

      <nav-menu-section-title
        v-if="!isCollapsed && showCampaigns"
        title="Kampanyalar"
      ></nav-menu-section-title>
      <nav-menu-link
        v-if="showCampaigns"
        title="Adverport Kampanyaları"
        :to="{ name: 'campaignsList' }"
        :icon="icons.mdiBullhorn"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showManagement"
        title="Kampanya URL Sağlığı"
        :to="{ name: 'campaignUrlHealth' }"
        :icon="icons.mdiLinkVariant"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showCampaigns"
        title="Network Offer'lar"
        :to="{ name: 'companiesList' }"
        :icon="icons.mdiCheckerboard"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showManagement"
        title="Link Raporları"
        :to="{ name: 'linkReports' }"
        :icon="icons.mdiLinkVariant"
      ></nav-menu-link>

      <nav-menu-section-title
        v-if="!isCollapsed && showAnalytics"
        title="Analitik"
      ></nav-menu-section-title>
      <nav-menu-link
        v-if="showAnalytics"
        title="Event Akışı"
        :to="{ name: 'analyticsEvents' }"
        :icon="icons.mdiChartTimeline"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showAnalytics"
        title="Journeyler"
        :to="{ name: 'analyticsJourneys' }"
        :icon="icons.mdiMapMarkerPath"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showAnalytics"
        title="Mail"
        :to="{ name: 'analyticsMail' }"
        :icon="icons.mdiEmailCheckOutline"
      ></nav-menu-link>

      <nav-menu-section-title
        v-if="!isCollapsed && showSystem"
        title="Sistem"
      ></nav-menu-section-title>
      <nav-menu-link
        v-if="showSystem"
        title="Log Explorer"
        :to="{ name: 'logExplorer' }"
        :icon="icons.mdiTextBoxSearchOutline"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showSystem"
        title="Cron Job İzleyici"
        :to="{ name: 'cronMonitor' }"
        :icon="icons.mdiTimerOutline"
      ></nav-menu-link>

      <nav-menu-section-title
        v-if="!isCollapsed && showSettings"
        title="Ayarlar"
      ></nav-menu-section-title>
      <nav-menu-link
        v-if="showSettings"
        title="Kategoriler"
        :to="{ name: 'categories' }"
        :icon="icons.mdiShape"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showSettings"
        title="Hesap Ayarları"
        :to="{ name: 'settings' }"
        :icon="icons.mdiCogOutline"
      ></nav-menu-link>

      <nav-menu-section-title
        v-if="!isCollapsed && showCommunication"
        title="İletişim"
      ></nav-menu-section-title>
      <nav-menu-link
        v-if="showCommunication"
        title="Bildirimler"
        :to="{ name: 'broadcastNotifications' }"
        :icon="icons.mdiBellOutline"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showCommunication"
        title="Bülten Aboneleri"
        :to="{ name: 'newsletterSubscribers' }"
        :icon="icons.mdiEmailOutline"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showCommunication"
        title="İletişim Talepleri"
        :to="{ name: 'contactRequests' }"
        :icon="icons.mdiBellOutline"
      ></nav-menu-link>
      <nav-menu-link
        v-if="showCommunication"
        title="WhatsApp Destek"
        :to="{ name: 'whatsappSupport' }"
        :icon="icons.mdiWhatsapp"
      ></nav-menu-link>
    </v-list>

    <div
      v-if="!isCollapsed && list"
      class="admin-sidebar__footer"
    >
      <div class="admin-sidebar__user">
        <v-avatar
          size="36"
          color="primary"
        >
          <span class="white--text text-caption font-weight-bold">{{ initials }}</span>
        </v-avatar>
        <div class="admin-sidebar__user-meta">
          <span class="admin-sidebar__user-name">{{ displayName }}</span>
          <span class="admin-sidebar__user-role">{{ roleTitle }}</span>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import * as icons from '@mdi/js'
import {
  getAccessToken, getPanelSession, hasAdminAccess, hasFinanceAccess,
} from '@/utils/panelSession'
import NavMenuLink from './components/NavMenuLink.vue'
import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue'

export default {
  components: {
    NavMenuLink,
    NavMenuSectionTitle,
  },
  props: {
    isDrawerCollapsed: {
      type: Boolean,
      default: false,
    },
    isMobileDrawerOpen: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    icons,
    list: {},
    hasSession: !!getAccessToken(),
  }),
  computed: {
    isCollapsed() {
      return !this.isMobile && this.isDrawerCollapsed
    },
    roleTitle() {
      if (this.list?.admin) {
        return 'Yönetim Ekibi'
      }

      if (this.list?.finance) {
        return 'Finans Ekibi'
      }

      return 'Panel Kullanıcısı'
    },
    displayName() {
      const fullName = [this.list?.name, this.list?.surname]
        .filter(Boolean)
        .join(' ')

      return fullName || 'Admin Kullanıcı'
    },
    initials() {
      const value = this.displayName
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part.charAt(0))
        .join('')
        .toUpperCase()

      return value || 'AP'
    },
    showPrimaryNavigation() {
      return this.hasSession && (this.list?.admin || this.list?.finance)
    },
    showManagement() {
      return hasAdminAccess(this.list)
    },
    showFinance() {
      return hasFinanceAccess(this.list)
    },
    showCampaigns() {
      return hasFinanceAccess(this.list)
    },
    showAnalytics() {
      return hasAdminAccess(this.list)
    },
    showSystem() {
      return hasAdminAccess(this.list)
    },
    showSettings() {
      return hasAdminAccess(this.list)
    },
    showCommunication() {
      return hasAdminAccess(this.list)
    },
  },
  watch: {
    '$route.fullPath': function routePathChanged() {
      if (this.isMobile) {
        this.$emit('update:is-mobile-drawer-open', false)
      }
    },
  },
  mounted() {
    this.list = getPanelSession() || {}
  },
  methods: {
    handleDrawerInput(val) {
      if (this.isMobile) {
        this.$emit('update:is-mobile-drawer-open', val)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.app-logo {
  transition: all 0.18s ease-in-out;

  .v-navigation-drawer--mini-variant & {
    transform: translateX(-1px);
  }
}

.app-navigation-menu {
  .v-list-item.vertical-nav-menu-link {
    ::v-deep .v-list-item__icon {
      .v-icon {
        transition: none !important;
      }
    }
  }
}
</style>
